import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentFaq from "@/pages/DepressionTreatmentFaq";
export const Route = createFileRoute("/depression-treatment-faq")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Faq | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Answers to common questions about depression treatment, TMS, SAINT TMS, SPRAVATO, and ketamine at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Depression Treatment Faq | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Answers to common questions about depression treatment, TMS, SAINT TMS, SPRAVATO, and ketamine at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/depression-treatment-faq",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-faq",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentFaq />;
}
